export default __webpack_public_path__ + "static/media/dashboard_psychiatry_session_icon.f64903ed.svg";